<script lang="ts">
  import { goto } from "@mateothegreat/svelte5-router";
  import { getBasePath } from "../utils";

  const { target, children, ...props }: any = $props();

  function navigate(ev: MouseEvent) {
    ev.preventDefault();
    goto(getBasePath() + target);
  }
</script>

<a href={getBasePath() + target} onclick={navigate} {...props}
  >{@render children?.()}</a
>
